<template>
    <portlet
            :icon="'fad fa-coins'"
            :title="'Kostenplaatsen'"
    >
        <template slot="portletBody">
            <form v-if="Can(rights.COSTCENTER_ADD)" @submit.prevent="addCostCenter()">
                <div class="row align-items-end mb-5">
                    <div class="col-sm-8 col-lg-10">
                        <label for="cost-center-name">Voeg een kostenplaats toe</label>
                        <input required
                               name="cost-center-name"
                               id="cost-center-name"
                               type="text"
                               class="form-control"
                               v-model="name">
                    </div>
                    <div class="col-sm-4 col-lg-2">
                        <button class="btn btn-primary btn-block">
                            Toevoegen
                        </button>
                    </div>
                </div>
            </form>
            <datatables
                    :tableClass="tableClass"
                    v-if="getCostCenters.length && renderedComponent && Can(rights.COSTCENTER_VIEW)"
                    :rows="getCostCenters"
                    :columns="columns"
                    tableID="costCenters"
                    :tableInitOptions="tableInitOptions"
                    routerLinkClass="dt-router-link"
                    :deleteFunction="deleteCostCenter"
                    deleteClass="delete"
                    :getDataClass="'get-data'"
                    @rowSelected="rowSelected"
            ></datatables>

            <edit-name-default
                    v-if="costCenter"
                    :title="'Kostenplaats aanpassen'"
                    :value="costCenter"
                    :name="modalId"
                    :showStandard="false"
                    @saveChanges="editCostCenter($event)"
            ></edit-name-default>

        </template>
    </portlet>
</template>

<script>
    import {mapGetters} from 'vuex'
    import editNameDefault from '../../components/editNameDefault'
    import {dataTables} from "../../components/mixins/dataTables";
    import {swalModals} from "../../components/mixins/swalModals.js";
    import { Can } from '../../../permission/ability.js';
    import { RIGHTS } from '../roles/rights';

    export default {
        mixins: [dataTables, swalModals],
        components: {editNameDefault},
        data() {
            return {
                rights: '',
                name: '',
                costCenter: null,
                oldName: '',
                tableInitOptions: {
                    order: [[0, "asc"]],
                },
                columns: [
                    {data: 'name', name: 'Naam', visible: true, searchable: true, responsivePriority: 1},
                    {
                        data: null, name: 'Opties', orderable: false, responsivePriority: 2,
                        render(data) {
                            var options = '';
                            if(Can(RIGHTS.COSTCENTER_EDIT)) {
                                options += '<i title="Kostenplaats aanpassen" class="far fa-edit action-icon get-data" data-target="#' + data.id + '" data-toggle="modal"></i>';
                            }

                            if(Can(RIGHTS.COSTCENTER_DELETE)) {
                                options += '<a class="delete action-icon dt-router-link" data-id="' + data.id + '"><i title="Verwijder" class="far fa-trash-alt delete"></i></a>';
                            }
                            return options;
                        }
                    },
                ],
            }
        },
        methods: {
            Can,
            rowSelected(value) {
                this.modalId = value.id;
                this.oldName = value.name;
                this.costCenter = {id: this.modalId, name: value.name};
            },
            addCostCenter() {
                let name = this.name.trim();
                if (!name) {
                    return;
                }
                this.$store.dispatch('costCenters/set', {name, department: this.$store.getters.getUserData.selectedDepartment}).then(() => {
                    this.$toasted.global.successRequest({
                        message: 'Kostenplaats aangemaakt',
                    });
                    this.name = '';

                    this.renderComponent();
                }).catch(() => {
                    this.$toasted.global.failedRequest();
                })
            },
            editCostCenter(costCenter) {
                // Pressing enter in the modal emits saveChanges without a payload
                costCenter = costCenter || this.costCenter;
                if (!costCenter || !costCenter.name || !costCenter.name.trim()) {
                    return;
                }
                let name = costCenter.name.trim();
                let oldName = this.oldName;

                $('.modal').modal('hide');
                $('.modal-backdrop').remove();

                this.$store.dispatch('costCenters/set', {
                    id: costCenter.id,
                    name,
                }).then(() => {
                    // Customers store the name, keep them in sync so the hours export stays correct
                    if (oldName && oldName !== name) {
                        return Promise.all(this.customersWithCostCenter(oldName).map(customer =>
                            this.$store.dispatch('customers/patch', {id: customer.id, costCenter: name})
                        ));
                    }
                }).then(() => {
                    this.oldName = name;
                    this.$toasted.global.successRequest({
                        message: 'Kostenplaats aangepast',
                    });
                }).catch(() => {
                    this.$toasted.global.failedRequest();
                });

                this.renderComponent();
            },
            deleteCostCenter(costCenter) {
                let id = costCenter.id;
                let linked = this.customersWithCostCenter(costCenter.name);
                // Block deleting while customers still use it, otherwise they keep a name that no longer exists
                if (linked.length) {
                    this.$swal({
                        title: 'Kostenplaats is nog in gebruik',
                        html: '<strong>' + _.escape(costCenter.name) + '</strong> is nog gekoppeld aan ' + linked.length + ' klant(en):<br>' +
                            linked.map(customer => _.escape(customer.name)).join(', ') +
                            '<br><br>Wijzig eerst de kostenplaats bij deze klanten.',
                        type: 'warning',
                        confirmButtonText: 'Sluiten',
                    });
                    return;
                }
                this.swalDelete(costCenter.name).then(result => {
                    if (result.value) {
                        this.$store.dispatch('costCenters/delete', id);

                        this.$toasted.global.successRequest({
                            message: 'Kostenplaats verwijderd',
                        });

                        this.renderComponent();
                    }
                })
            },
            customersWithCostCenter(name) {
                return _.toArray(this.$store.state.customers.customers).filter(customer => customer.costCenter === name);
            },
        },
        computed: {
            ...mapGetters('costCenters', [
                    'getCostCenters',
                ]
            ),
        },
        created() {
            this.rights = RIGHTS;
        }
    };
</script>
